module.exports = __webpack_public_path__ + "img/Bess Finance.f6460b33.png";